var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoc2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 54,
    viewBox: "0 0 50 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.5098 7.17429L34.6041 12.442H28.5098V7.17429ZM40.2906 44.7208C39.0453 44.7208 38.0314 45.7237 38.0314 46.969V49.5037H4.50735V4.49633H24.0024V14.6792C24.0024 15.9245 25.0163 16.9273 26.2616 16.9273H38.0424V30.4163C38.0424 31.6616 39.0563 32.6645 40.3016 32.6645C41.5469 32.6645 42.5608 31.6616 42.5608 30.4163V14.3706C42.5608 13.7204 42.2743 13.0922 41.7784 12.6735L27.7384 0.55102C27.3306 0.198367 26.8016 0 26.2616 0H2.25918C1.01388 0 0 1.00286 0 2.24816V51.7518C0 52.9971 1.01388 54 2.25918 54H40.3016C41.5469 54 42.5608 52.9971 42.5608 51.7518V46.969C42.5498 45.7237 41.5359 44.7208 40.2906 44.7208Z",
    fill: "#3DC8AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.2731 20.7074H12.4201C11.1748 20.7074 10.1609 21.7103 10.1609 22.9556C10.1609 24.2009 11.1748 25.2037 12.4201 25.2037H30.2842C31.5295 25.2037 32.5433 24.2009 32.5433 22.9556C32.5433 21.7103 31.5184 20.7074 30.2731 20.7074Z",
    fill: "#3DC8AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.2731 31.7828H12.4201C11.1748 31.7828 10.1609 32.7857 10.1609 34.031C10.1609 35.2763 11.1748 36.2792 12.4201 36.2792H30.2842C31.5295 36.2792 32.5433 35.2763 32.5433 34.031C32.5323 32.7967 31.5184 31.7828 30.2731 31.7828Z",
    fill: "#3DC8AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M49.5807 33.7775C49.4705 32.5432 48.3685 31.6285 47.1342 31.7387C42.0428 32.1906 37.2048 37.7559 34.7142 41.1391L33.2485 39.4751C32.422 38.5383 31.0003 38.4502 30.0636 39.2767C29.1269 40.1032 29.0387 41.5249 29.8652 42.4506L33.2485 46.2857C34.5709 47.5971 36.0256 47.3547 36.8522 45.9881C38.3289 43.5526 43.5416 36.5767 47.5309 36.224C48.7762 36.1028 49.6909 35.0118 49.5807 33.7775Z",
    fill: "#3DC8AF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc2);
export default __webpack_public_path__ + "static/media/doc-2.213353e639f6f1033616967f173dc898.svg";
export { ForwardRef as ReactComponent };